import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-t border-primary/10 bg-background py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-21" data-mp="1anxnlqbmowbh">
        <SectionHeading id="bonus-title" data-id="element-22" data-mp="1aop7i3vv55lx">The {totalBonuses} <span className="text-accent" data-id="element-23" data-mp="15pw2kzun6mxd">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-primary/25 bg-surface shadow-lg shadow-black/30" data-id="element-24" data-mp="1jgr4ttamy5rz">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-primary/15 p-5 last:border-b-0 sm:p-6" data-id="element-25" data-mp="r0838460tyca" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-primary/40 bg-background text-primary" data-id="element-26" data-mp="2jixqooh9uyz9">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-27" data-mp="2oitt4jabmicp" />
                </span>
                <div data-id="element-28" data-mp="1qvbo9jjs60dz">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-primary" data-id="element-29" data-mp="1vsbp9g1rwcy8">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-bold leading-tight text-foreground" data-id="element-30" data-mp="20qvf3rjhm8vv">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground/90" data-id="element-31" data-mp="25qrlfxfnqcel">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-accent bg-surface px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-32" data-mp="3h5mwzaj0bxqx">
          <div data-id="element-33" data-mp="1c4asgwdpx7e9">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-34" data-mp="1c4u1fnle4lg5">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-primary decoration-2" data-id="element-35" data-mp="1q320q25wfyuh">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-36" data-mp="yc4engy1fchz">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-37" data-mp="yd5s1s2j0b2v">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-accent" data-id="element-38" data-mp="tbq3vr51xog9">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-39" data-mp="1772aowwhf5dj" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}